import { actionTypes } from 'store/utils';

export const types = {
  ...actionTypes('UPLOAD_FILE'),
  ...actionTypes('SAVE_TASK'),
  ...actionTypes('SUBMIT_TASK'),
  ...actionTypes('GET_FORM_DATA'),
  ...actionTypes('GET_TASK_DATA'),
  ...actionTypes('QUERY_TASKS'),
  ...actionTypes('GET_FORM_UPLOADS'),
  ...actionTypes('GET_PROCESS_INSTANCES'),
  ...actionTypes('START_NEW'),
  ...actionTypes('CLAIM_ACTIVE'),
  ...actionTypes('CLAIM_ACTIVE_VIEW_MODE'),
  ...actionTypes('CLEAR_FORM'),
  ...actionTypes('APPROVE_AUDIT'),
  ...actionTypes('REJECT_AUDIT'),
  ...actionTypes('APPROVE_OBJECTION'),
  ...actionTypes('REJECT_OBJECTION'),
  ...actionTypes('REJECT_TASK'),
  ...actionTypes('SUBMIT_CONSENT'),
  ...actionTypes('OPEN_UPLOADED_FILE'),
  ...actionTypes('DOWNLOAD_UPLOADED_FILE'),
  ...actionTypes('CHECK_UNIQUENESS'),
  ...actionTypes('THIRD_PARTY_VALIDATIONS'),
  ...actionTypes('GET_BY_CODE'),
  ...actionTypes('LOAD_SYSTEM_LOCALES'),
  ...actionTypes('GET_APP_CONFIG'),
  ...actionTypes('GET_PROJECT_PLAN_INFO'),
  ...actionTypes('GET_OTP'),
  ...actionTypes('VALIDATE_OTP'),
  ...actionTypes('GET_TAXIS_DATA_BY_TK'),
  ...actionTypes('GET_TAXIS_DATA_BY_ABI_TK'),
  ...actionTypes('GET_MAINFORM_DETAILS'),
  ...actionTypes('DELETE_DOCUMENT'),
  ...actionTypes('SUBMIT_CONSENT'),
  ...actionTypes('INCOME_VALIDATION'),
  ...actionTypes('INDIVIDUAL_INCOME_VALIDATION'),
  ...actionTypes('FAMILY_INCOME_VALIDATION'),
  ...actionTypes('SUPPLIER_UPDATE_EQUIPMENT'), 
  ...actionTypes('SEND_OTP_VOUCHER'),
  ...actionTypes('GET_VOUCHER'),
  ...actionTypes('GET_VOUCHER_AUDITOR'),
  ...actionTypes('VOUCHER_AUDITOR_SET_AUDIT_STATUS'),
  ...actionTypes('START_VOUCHER_AUDIT'),
  CLEAR_ADVISOR_FIELDS: 'CLEAR_ADVISOR_FIELDS',
  UPDATE_FORM_FIELD_FORMS: 'UPDATE_FORM_FIELD_FORMS',
  UPDATE_FORM_VALIDITY: 'UPDATE_FORM_VALIDITY',
  TRIGGER_LOADING: 'TRIGGER_LOADING',
  DISABLE_IN_LOADING: 'DISABLE_IN_LOADING',
  CLEAR_EXCEL_DATA: 'CLEAR_EXCEL_DATA',
  SOREFSIS_ERROR: 'SOREFSIS_ERROR',
  CLEAR_EXCEL_ERROR: 'CLEAR_EXCEL_ERROR',
  UPDATE_BUSINESS_PLAN_EXPENSE :'UPDATE_BUSINESS_PLAN_EXPENSE',
  SET_FORM_INITIATED: 'SET_FORM_INITIATED',
  SET_FORM_INFO: 'SET_FORM_INFO',
  UPDATE_USER: {
    SUCCESS: 'UPDATE_USER_SUCCESS'
  },
  RESET_USER: 'RESET_USER',
  RESET_FORM: 'RESET_FORM',
};